module.exports = __webpack_public_path__ + "Roboto-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.woff2
// module id = 93
// module chunks = 0